module.exports = __webpack_public_path__ + "img/asterisk.e54fb86d.svg";